<template>
  <div class="zptj">
    <mt-header title="展品详情">
      <span slot="left" @click="()=>this.$router.push('/exhibitor')">
        <i class="iconfont icon-left"></i>
        返回
      </span>
    </mt-header>
    <div class="mintHeader"></div>
    <div class="detailContent">
      <div>
        <div class="zptjTop">
            <p>{{list.class_name_cn}}</p>
            <div class="datilImg">
              <img :src="list.img_url" alt="" />
              <div @click="isCollect(list.id)">
                <img v-show="like1*1==1" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like.png" alt="" />
                <img v-show="like1*1==2" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like_1.png" alt="" />
              </div>
            </div>
        </div>
        <div class="abstract">
          <div>{{list.prodetails_cn}}</div>
          <h5>展品类目</h5>
          <p>{{list.class_name_cn}}</p>
          <h5>展商名称</h5>
          <p>{{list.corpname_cn}}</p>
          <h5>地址</h5>
          <p>{{list.address_cn}}</p>
          <h5>电话</h5>
          <p>{{list.phone}}</p>
        </div>
        <h4>相关展品推荐</h4>
        <div class="slider">
          <ul class="sliderList" ref="sliderList">
            <li v-for="(item,i) in xgcp.list" :key="i" @click="updateItem(item)">
              <div>
                <img :src="item.img_url" alt="" />
              </div>
              <p>{{item.corpname_cn}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ul class="footer">
      <li @click="isCollect(list.id)">
        <div>
          <img v-show="like1*1==1" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like.png" alt="" />
          <img v-show="like1*1==2" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like_1.png" alt="" />
        </div>
        <span>收藏</span>
      </li>
      <li @click="popup">
        <i 
        class="iconfont icon-liuyan collect" 
        :class="like2?'hue':''"></i>
        <span>询盘</span>
      </li>
      <li @click="isCorpApp(list.ocid)">
        <i 
        class="iconfont collect icon-dianhua1" 
        :class="meet?'':'hue'"></i>
        <span>约见</span>
      </li>
      
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import { Header } from 'mint-ui';
import { MessageBox } from 'mint-ui';
Vue.component(Header.name, Header);
import "mint-ui/lib/header/style.css"
import "mint-ui/lib/message-box/style.css"
import {reqDetails, reqExhibitList,reqProColl, reqProCollDo, reqCorpApp, reqCorpAppDo, reqAddNote} from "../../../api"
export default {
  data () {
    return {
      like1:1,
      like2:false,
      meet:1,
      id:Number,
      ocid:Number,
      list:{},
      xgcp:{},
      falg:false
    }
  },
  mounted(){
    // 截取字符串
    let id = this.$route.path.split('/')
    this.id=id[id.length-2]*1
    this.ocid = id[id.length-1]*1
    this.reqDetail(this.id)
    this.initCollect(this.id)
    this.initCorpApp(this.ocid)
  },
  methods:{
    // popup  弹窗  未写完 
    popup(){
      MessageBox.prompt('请输入要询问的内容','请输入留言').then(()=>{
      })
    },
    // 询盘上传请求
    async reqAddCon(){
      if (this.falg) {
        return 
      }
      this.falg = true
      const response = await reqAddNote(this.list.id,this.textarea)
      if(response.code==0){
        // this.isPath1(this)
        // this.$store.dispatch("dialog",true)
        this.err(this,'参展商未在线，请稍后重试')
      }else if (response.code==1) {
        this.centerDialogVisible=false
        this.textarea = ''
        this.success(this,'发送成功')
      }
      this.falg=false
    },
    // 请求列表
    async reqDetail(id){
      const response = await reqDetails(id)
      if(response.code==0){
          this.list=response.resilt[0]
          this.reqRelatedExh(response.resilt[0].fk_parentid)
      }else{
        this.$router.push("/")
      }
    },
    // 相关产品请求
    async reqRelatedExh(id){
      const response = await reqExhibitList(1,id)
      if(response.code==0){
        this.xgcp={list:response.resilt,name:"相关产品"}
      }
    },
    //跳转
    updateItem(item){
      this.$router.push('/exhibit/details/'+item.id+'/'+item.ocid)
      this.reqDetail(item.id)
    },
    // 初始获取收藏状态
    async initCollect(id){
      const response = await reqProColl(id)
      if (response.code==0) {
        this.like1=response.is_coll
      }else{
        this.collect = 1
      }
    },
    // 修改收藏状态
    async isCollect(id){
      const response = await reqProCollDo(id)
      if (response.code==0) {
        this.like1=response.is_coll
      }
    },
    // 初始化约见状态++++
    async initCorpApp(ocid){
      const response = await reqCorpApp(ocid)
      if (response.code==0) {
        this.meet=response.is_coll
      }
    },
    // 修改约见状态
    async isCorpApp(ocid){
      const response = await reqCorpAppDo(ocid)
      if (response.code==0) {
        this.meet=response.is_coll
      }
    },
  }
  
}
</script>

<style scoped>
  .zptj{
    height: 100%;  
    background-color: #f3f3f3;  
  }
  .newListPage{
    height: 100%;
    background-color: white;
    overflow: hidden;
  }
  .mint-header{
    height: 40px;
    background-color: #008baf;
  }
  .detailContent{
    height: calc(100vh - 90px);
    overflow-y: auto;
  }
  .zptjTop{
    background-color: #008baf;
    background: url('http://www.cippe.com.cn/miniprogram/zpxqhead.jpg') no-repeat ;
    background-size: 100% 100%;
    height: 300px;
    padding: 0 35px;
  }
  .zptjTop p{
    padding: 25px 0;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: white;
  }
  .datilImg{
    position: relative;
    width: 100%;
    height: 200px;
    /* background-color: white; */
  }
  .datilImg div{
    position: absolute;
    right: 0;
    top: 0;
    /* font-size: 46px; */
    color: #aaa;
    width: 23px;
  }
  .abstract{
    padding: 0 20px;
    background-color: #ecfafe;
    box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, .3);
  }
  .abstract >div{
    text-align: center;
    font-size:13px;
    color: #666666;
    padding: 10px 0 20px;
  }
  .abstract h5{
    font-size: 15px;
    padding-bottom: 8px;
  }
  .abstract p{
    color: #666666;
    padding-bottom: 20px;
  }
  .detailContent h4{
    font-size: 16px;
    padding: 25px 0;
    text-align: center;
  }
  .slider{
    width: 100%;
    overflow: hidden;
  }
  .sliderList{
    margin: 0 10px;
    height: 150px;
    white-space: nowrap;
    overflow-x: auto;
  }
  .sliderList li{
    display: inline-block;
    width: 100px;
    margin: 0 5px;
    text-align: center;
    vertical-align: top;
  }
  .sliderList li:first-child{
    margin-left: 0;
  }
  .sliderList li div{
    width: 100px;
    height: 100px;
    overflow: hidden;
    box-shadow: 3px 5px 10px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    background-color: white;
  }
  .sliderList li p{
    white-space:pre-wrap;
    margin-top: 10px;
    padding:0 2px;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }


  .footer{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    text-align: center;
    display: flex;
    justify-content: space-around;
    box-shadow: 0 5px 5px 5px rgba(0, 0, 0, .3) ;
  }
  .footer li{
    padding-top: 3px;
    list-style: none;
    width: 33%;
    border-left: 1px solid white;
    background-color: #f3f3f3;
  }
  .footer li :first-child{
    border: none;
  }
  .footer li div{
    width: 27px;
    margin: 0 auto;
  }
  .footer li i{
    margin: 0 auto;
    font-size: 27px;
    font-size: 27px;
    display: block;
    color: #8b8a8a;
  }
  .footer li .hue{
    color: #ff840c;
  }
</style>